<template>
  <v-dialog :value="show" max-width="800" @input="onInput">
    <v-card>
      <v-card-title class="text-h5">AI Memory Usage</v-card-title>
      <v-card-text>
        <div v-if="!hasData">No memory usage data</div>
        <v-list v-else dense class="py-0 ai-memory-usage">
          <template v-for="(f, idx) in facts">
            <v-list-item :key="(f.id || idx) + '-item'">
              <v-list-item-icon class="id-icon">
                <div class="d-flex flex-column align-center id-stack">
                  <v-icon color="amber darken-2" small
                    >mdi-lightbulb-on-outline</v-icon
                  >
                  <v-chip
                    v-if="f.id"
                    small
                    label
                    class="mt-1 primary--text text--darken-2"
                    color="primary lighten-5"
                  >
                    ID: {{ f.id }}
                  </v-chip>
                </div>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  <span class="primary--text text--darken-2 mr-1">Fact:</span>
                  {{ f.fact }}
                </v-list-item-title>
                <v-list-item-subtitle
                  v-if="f.reason"
                  class="grey--text text--darken-1"
                >
                  <span class="info--text text--darken-1 mr-1">Reason:</span>
                  {{ f.reason }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="idx < facts.length - 1"
              :key="(f.id || idx) + '-div'"
              inset
            />
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" @click="$emit('close')">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AiMemoryUsageDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    memoryData: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    hasData() {
      return Array.isArray(this.memoryData) && this.memoryData.length > 0
    },
    facts() {
      return Array.isArray(this.memoryData) ? this.memoryData : []
    },
  },
  methods: {
    onInput(val) {
      if (!val) this.$emit('close')
    },
  },
}
</script>

<style scoped>
.font-weight-medium {
  font-weight: 600;
}
.ai-memory-usage .v-list-item__subtitle,
.ai-memory-usage .v-list-item__title {
  white-space: normal;
}
.id-stack {
  min-width: 64px;
}
.id-icon {
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  height: auto !important;
  min-height: 0;
  overflow: visible !important;
}
.id-icon .v-chip {
  height: auto;
  line-height: 1.2;
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>
